import { graphql } from '@teachino/shared-infrastructure';

export const baseLicenseFragment = graphql(`
  fragment BaseLicense on License {
    holderType
    features {
      key
    }
    plan {
      key
      type
    }
  }
`);
